import {apiRequest} from "./ApiRequest";

const getGroups = params => {
    return apiRequest("get", "/groups", null, params).then(response => {
        return Promise.resolve(response.data);
    });
};

const editGroup = (id, data) => {
    return apiRequest("put", "/groups/" + id, data).then(response => {
        const tasks = [];
        if (data.addedMembers) {
            tasks.push(apiRequest("post", `/groups/${id}/members`, data.addedMembers));
        }
        if (data.deletedMembers) {
            tasks.push(apiRequest("delete", `/groups/${id}/members`, data.deletedMembers));
        }
        return Promise.all(tasks).then(() => {
            return Promise.resolve(response.data);
        });
    });
};

const createGroup = data => {
    return apiRequest("post", "/groups", data).then(response => {
        if (data.addedMembers) {
            apiRequest("post", `/groups/${response.data.id}/members`, data.addedMembers);
        }
        return Promise.resolve(response.data);
    });
};

const deleteGroup = id => {
    return apiRequest("delete", "/groups/" + id).then(response => {
        return Promise.resolve(response.data);
    });
};

const getGroupMembers = id => {
    return apiRequest("get", `/groups/${id}/members`).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getGroups, editGroup, createGroup, deleteGroup, getGroupMembers};
